import { Flex } from "@/atoms"
import { InformationPopover } from "@/molecules/InformationPopover"

import styles from "./AsideFooter.module.scss"

import type { AsideFooterProps } from "./AsideFooter.types"

export const AsideFooter = ({ label, tooltip }: AsideFooterProps) => {
  return (
    <Flex gap={4} align="center" className={styles.messageWrapper}>
      <InformationPopover.Popover
        open={tooltip ? undefined : false}
        content={
          <InformationPopover.CommonTemplate>
            {tooltip}
          </InformationPopover.CommonTemplate>
        }
        placement="topRight"
      />
      <span>{label}</span>
    </Flex>
  )
}
